import { defaultNetwork, wagmiConfig } from '@/constants/walletConnectionConfig'
import { useEffect } from 'react'
import { useAccount, useSwitchChain } from 'wagmi'

export const useCheckNetworkChainId = () => {
  const { isConnected, chainId } = useAccount()
  const { switchChain } = useSwitchChain({ config: wagmiConfig })

  useEffect(() => {
    if (isConnected && chainId && chainId !== Number(defaultNetwork.id)) {
      switchChain?.({ chainId: Number(defaultNetwork.id) })
    }
  }, [chainId])
}
